import { UserEndpoints } from 'src/client/user/constants'
import { IMAGES } from 'src/assets'
import clsx from 'clsx'
import { convertNumberToCompactFormat } from 'src/utils/convertNumberToCompactFormat'
import i18n from 'src/i18n'
import { useUser } from 'src/hook/useUser'
import { CommentAvatarListProps } from './commentAvatarList.types'
import { Avatar, List, UserMention, Wrapper } from './commentAvatarList.styles'

const CommentAvatarList = ({
  users,
  commentsCount,
  hasUnseenMentionInComments,
  className,
  onClick
}: CommentAvatarListProps) => {
  const { user } = useUser()

  const userName = user?.socialName || user?.name
  const isValidUserList = Array.isArray(users) && users?.length > 0

  const attributes = onClick && {
    role: 'button',
    tabIndex: 0,
    onClick: onClick,
    onKeyDown: onClick
  }

  if (!isValidUserList) {
    return null
  }

  const handleError = ({ currentTarget }) => {
    currentTarget.onerror = null
    currentTarget.src = IMAGES.AVATAR_OWNER_DEFAULT
  }

  return (
    <Wrapper
      className={clsx(
        '_d-flex _flex-shrink-0 _align-items-center _p-2 _rounded',
        { '_cursor-pointer': onClick },
        className
      )}
      {...attributes}
    >
      <div className="_d-flex _flex-shrink-0 _align-items-center _rounded-sm">
        <List className="_d-inline-flex _mb-0">
          {users?.map(({ ucode }) => (
            <li key={ucode}>
              <Avatar
                src={UserEndpoints.getUserAvatarByUcode({
                  ucode,
                  options: { dimensions: '24x24' }
                })}
                alt="avatar"
                className="_rounded-circle"
                loading="lazy"
                onError={handleError}
              />
            </li>
          ))}
        </List>

        <span className="_font-14 _text-blue-light _ml-2">
          {convertNumberToCompactFormat(commentsCount)}
          {commentsCount === 1
            ? i18n.t('comments.comment_one')
            : i18n.t('comments.comment_other', {
                comments_count: convertNumberToCompactFormat(commentsCount)
              })}
        </span>
      </div>

      {hasUnseenMentionInComments && (
        <UserMention
          className="mention-highlight _position-relative _font-14 _ml-4"
          data-type="mention"
        >
          @{userName}
        </UserMention>
      )}
    </Wrapper>
  )
}

export default CommentAvatarList
